<template>
  <!-- Tutto avvolto da top-bar -->
  <div id="top-bar" class="top-bar">
    <!-- Riga 1: logo + link + logout -->
    <div
      class="top-bar-header"
      :class="{ 'login-layout': $route.path === '/login' }"
    >
      <!-- Logo con link Home -->
      <a
        @click="goToHome"
        role="button"
        class="logo-link"
        :title="$route.path !== '/login' ? 'Clicca per tornare alla home' : ''"
        :aria-label="
          $route.path !== '/login' ? 'Clicca per tornare alla home' : ''
        "
      >
        <img
          id="main-logo"
          src="@/assets/emmamaison.png"
          alt="Emma Maison logo"
        />
      </a>

      <!-- Breadcrumb -->
      <div id="breadcrumb-container" v-if="!$route.meta.hideUrlIndex">
        <div id="breadcrumb">
          <template v-for="(crumb, index) in breadcrumbs" :key="index">
            <router-link
              v-if="index < breadcrumbs.length - 1"
              :to="crumb.path"
              class="breadcrumb-link"
            >
              {{ crumb.name }}
            </router-link>
            <span v-if="index < breadcrumbs.length - 1"> > </span>
            <template v-else>
              <span>{{ crumb.name }}</span>
              <span
                v-if="
                  $route.name === 'drafts' &&
                  draftsCount !== null &&
                  draftsCount > 0
                "
                class="breadcrumb-drafts-badge"
                :aria-label="`${draftsCount} bozze`"
                >{{ draftsCount }}</span
              >
            </template>
          </template>
        </div>
      </div>

      <!-- Hamburger toggle (solo mobile) -->
      <!-- [sc-49210] niente menu account/logout nelle pagine per utenti non
           loggati (login, recupero e reset password: meta.requiresGuest) -->
      <button
        v-if="!$route.meta.requiresGuest"
        class="hamburger-toggle"
        @click="toggleMenu"
        aria-label="Apri menu"
      >
        <i :class="menuOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'"></i>
      </button>

      <!-- Link a destra -->
      <div
        class="links"
        :class="{ open: menuOpen }"
        v-if="!$route.meta.requiresGuest"
      >
        <!-- Account Link -->
        <button
          v-if="!$route.meta.hideAccountLink"
          @click="goToAccount"
          id="account-button"
          class="account-button"
          :title="
            $route.path !== '/login'
              ? 'Clicca per andare alla pagina Account'
              : ''
          "
          :aria-label="
            $route.path !== '/login'
              ? 'Clicca per andare alla pagina Account'
              : ''
          "
        >
          <i class="fa-solid fa-user"></i>
        </button>

        <!-- Logout Link -->
        <button
          id="logout-button"
          @click="logout"
          :title="
            $route.path !== '/login' ? 'Clicca per effettuare il logout' : ''
          "
          :aria-label="
            $route.path !== '/login' ? 'Clicca per effettuare il logout' : ''
          "
        >
          <i class="fa-solid fa-right-from-bracket"></i>
        </button>
      </div>

      <!-- Overlay per chiudere il dropdown -->
      <div v-if="menuOpen" class="menu-overlay" @click="menuOpen = false"></div>
    </div>
  </div>
</template>

<script>
import { setAuth } from "../router";

export default {
  name: "TopBar",
  data() {
    return {
      breadcrumbs: [],
      menuOpen: false,
    };
  },
  computed: {
    draftsCount() {
      return this.$store.getters["drafts/count"];
    },
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler() {
        this.breadcrumbs = this.generateBreadcrumbs();
        this.menuOpen = false;
      },
    },
  },
  methods: {
    generateBreadcrumbs() {
      return this.$route.matched.map((matchedRoute) => ({
        name: matchedRoute.meta.breadcrumb || matchedRoute.name,
        path: matchedRoute.path,
      }));
    },

    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },

    goToAccount() {
      this.menuOpen = false;
      if (this.$route.path !== "/login") {
        this.$router.push("/home/account");
      }
      return;
    },

    goToHome() {
      if (this.$route.path !== "/login") {
        this.$router.push("/home");
      }
      return;
    },

    async logout() {
      this.menuOpen = false;

      if (this.$route.path === "/login") {
        return;
      }

      try {
        const response = await this.$axios.post("/auth/logout");
        if (response.status === 200) {
          setAuth(false); // Aggiorna lo stato di autenticazione
          this.successMessage = "Logout effettuato con successo!";
          this.$toast.success(this.successMessage);
          setTimeout(async () => {
            await this.$router.push("/login");
            setTimeout(() => {
              this.successMessage = "";
            }, 1500);
          }, 2500);
        }
      } catch (error) {
        this.errorMessage = "Errore durante il logout";
        this.$toast.error(this.errorMessage);
        setTimeout(() => {
          this.errorMessage = "";
        }, 2000);
      }
    },
  },
};
</script>

<style src="@/css/App.css"></style>
